import React from 'react';
import { Play, Award, Building2, Globe } from 'lucide-react';

// Embassy Group Logo URL - Using local file for reliability
const EMBASSY_LOGO = "/embassy-logo.png";

const AboutSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#0d1f35] to-[#0a1628]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content Side */}
          <div>
            <span className="text-[#c9a961] text-sm font-semibold tracking-widest uppercase">Legacy of Excellence</span>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mt-3 mb-8">About Embassy Group</h2>
            
            {/* Logo */}
            <div className="mb-8">
              <img 
                src={EMBASSY_LOGO} 
                alt="Embassy Group Logo - Developer of Embassy Verde 2.0 and Embassy Springs" 
                className="h-16 w-auto object-contain"
              />
            </div>
            
            <p className="text-white/70 text-lg leading-relaxed mb-6">
              Founded in 1993, <strong className="text-white">Embassy Group</strong> is one of India's largest real estate conglomerates with a broad portfolio of over 66 million sq. ft. of prime commercial, residential, retail, hospitality, services, and educational spaces across Delhi NCR, Bangalore, Chennai, Pune, Mumbai, Noida and Trivandrum.
            </p>
            
            <p className="text-white/70 text-lg leading-relaxed mb-6">
              <strong className="text-[#c9a961]">Embassy Verde 2.0</strong> is the latest addition to the prestigious <strong className="text-white">Embassy Springs</strong> township - a 288-acre integrated community offering <strong className="text-white">Embassy Verde apartments</strong>, villas, plots, senior living, and commercial spaces in Devanahalli, North Bangalore.
            </p>
            
            <p className="text-white/60 text-base leading-relaxed mb-8">
              This <strong>Embassy New Launch</strong> project brings luxury living with world-class amenities to one of Bangalore's fastest-growing corridors, just minutes from the International Airport.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center p-4 bg-white/5 rounded-xl border border-white/10">
                <Building2 className="w-8 h-8 text-[#c9a961] mx-auto mb-2" />
                <p className="text-3xl font-bold text-white">66M+</p>
                <p className="text-white/60 text-sm">Sq. Ft. Portfolio</p>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-xl border border-white/10">
                <Award className="w-8 h-8 text-[#c9a961] mx-auto mb-2" />
                <p className="text-3xl font-bold text-white">30+</p>
                <p className="text-white/60 text-sm">Years Legacy</p>
              </div>
              <div className="text-center p-4 bg-white/5 rounded-xl border border-white/10">
                <Globe className="w-8 h-8 text-[#c9a961] mx-auto mb-2" />
                <p className="text-3xl font-bold text-white">8+</p>
                <p className="text-white/60 text-sm">Cities Presence</p>
              </div>
            </div>
          </div>

          {/* Video Side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://images.unsplash.com/photo-1628744876497-eb30460be9f6?w=800&q=80"
                alt="Embassy Verde 2.0 Interior - Luxury Apartments at Embassy Springs Devanahalli"
                className="w-full h-[450px] object-cover"
              />
              <div className="absolute inset-0 bg-[#0a1628]/40" />
              
              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center">
                <button 
                  className="group relative w-24 h-24 bg-[#c9a961] rounded-full flex items-center justify-center shadow-xl shadow-[#c9a961]/30 hover:scale-110 transition-transform duration-300"
                  aria-label="Play Embassy Verde project video"
                >
                  <Play className="w-10 h-10 text-[#0a1628] ml-1" fill="currentColor" />
                  <div className="absolute inset-0 rounded-full border-2 border-[#c9a961] animate-ping opacity-50" />
                </button>
              </div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-gradient-to-br from-[#c9a961] to-[#8b7355] rounded-2xl p-5 shadow-xl hidden md:block">
              <p className="text-[#0a1628] font-bold text-lg">India's First</p>
              <p className="text-[#0a1628]/80 text-sm">Publicly Traded REIT</p>
            </div>
          </div>
        </div>
        
        {/* SEO Content Section */}
        <div className="mt-20 pt-12 border-t border-white/10">
          <h3 className="text-2xl font-bold text-white mb-6">Why Choose Embassy Verde 2.0?</h3>
          <div className="grid md:grid-cols-2 gap-8 text-white/60">
            <div>
              <h4 className="text-[#c9a961] font-semibold mb-3">Embassy Springs Verde - Premium Living</h4>
              <p className="leading-relaxed">
                Embassy Verde 2.0 offers premium 1, 2, 2.5 & 3 BHK apartments within the expansive Embassy Springs township. As the latest Embassy New Launch, it combines modern architecture with sustainable living, making it the perfect choice for families seeking luxury homes in North Bangalore.
              </p>
            </div>
            <div>
              <h4 className="text-[#c9a961] font-semibold mb-3">Embassy Verde Apartments Features</h4>
              <p className="leading-relaxed">
                Each Embassy Verde apartment is thoughtfully designed with spacious layouts, premium finishes, and stunning views. The project offers world-class amenities including swimming pools, clubhouse, sports courts, and landscaped gardens - all within a secure, gated community.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
